// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"16d726d1","237":"e5967d4a","408":"50ff4bee","609":"11ba45d4","708":"50b23c83","853":"219d21c0"}[chunkId] + ".chunk.js";
};